import { render, staticRenderFns } from "./primary-tag.vue?vue&type=template&id=01bf0b79"
import script from "./primary-tag.vue?vue&type=script&lang=js"
export * from "./primary-tag.vue?vue&type=script&lang=js"
import style0 from "./primary-tag.vue?vue&type=style&index=0&id=01bf0b79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports